import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  AccountCreateDto,
  AccountDto,
  AccountExcelDownloadDto,
  AccountUpdateDto,
} from '../proxy/controlling/dtos/account';
import { ACCOUNT_CONFIG, ACCOUNT_FIELDS } from './account.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-account',
  imports: [
    CommonModule,
    ZnHierarchicalViewComponent,
    GenericForm,
  ],
  providers: [ListService, AccountService, ConfirmationService],
  templateUrl: './account.html',
  styleUrl: './account.scss',
})
export class Account extends BaseHierarchicalCrudComponent<
  AccountDto,
  AccountCreateDto,
  AccountUpdateDto,
  AccountExcelDownloadDto
> {
  service = inject(AccountService);
  config = ACCOUNT_CONFIG;
  fields = ACCOUNT_FIELDS;

  protected prepareUpdateDto(data: any, selected: AccountDto): AccountUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Account';
  }
}
